import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__generation_create_for_field_consumer } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create_for_field_consumer';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_create_for_field_consumer = createAsyncThunkSafe<void, DTO_REQUEST__generation_create_for_field_consumer>(
  ENUM__network_event_client_to_server.GENERATION_CREATE_FOR_FIELD_CONSUMER,
  async (request, thunk_api): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_CREATE_FOR_FIELD_CONSUMER, request);
  },
);

export function INIT_REMOTE__generation_create_for_field_consumer(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_create_for_field_consumer.pending, (state, action) => {})
    .addCase(REMOTE__generation_create_for_field_consumer.rejected, (state, action) => {})
    .addCase(REMOTE__generation_create_for_field_consumer.fulfilled, (state, action: PayloadAction) => {});
}
